import React, { useRef } from 'react';
import { Link } from "react-router-dom";
import Card from "./Card";

function Services() {
  const carouselRef = useRef(null);

  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.querySelector('.carousel-card').offsetWidth;
      const scrollAmount = cardWidth;
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };


  return (
    <section className="container services" id="services" aria-labelledby="services-heading">
        <h2 className="main-title text-center" id="services-heading">Solar Panel Installation Services in India</h2>
        <p className="text-center" style={{fontSize: '18px', color: '#666', marginBottom: '2rem'}}>Expert solar solutions for residential, commercial, and utility-scale projects with transparent pricing and government subsidies</p>
        <div className="services-carousel-wrapper">
          <button 
            className="carousel-btn carousel-btn-left" 
            onClick={() => scrollCarousel('left')}
            aria-label="Scroll left"
          >
            &#8249;
          </button>
          <div className="services-carousel" ref={carouselRef}>
            <article className="carousel-card">
              <Link to="/utility-scale-solar" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Card 
                  title="Enterprise Power Solutions" 
                  img="card3.png" 
                  text="Group Captive, Fully Captive, Hybrid, BESS, VPPA, and Group PPA models for enterprise energy security" 
                />
              </Link>
            </article>
            <article className="carousel-card">
              <Link to="/solar-cold-storage" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Card 
                  title="Rooftop Solar for Cold Storage" 
                  img="Cold storage solar.png" 
                  text="Reduce energy costs and carbon footprint with dedicated solar + storage solutions designed for temperature-controlled logistics and food preservation infrastructure" 
                />
              </Link>
            </article>
            <article className="carousel-card">
              <Link to="/solar-warehouses" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Card 
                  title="Rooftop Solar for Warehouses" 
                  img="stock image commercial change.jpg" 
                  text="Energy-efficient solutions for distribution centers, e-commerce fulfillment, and third-party logistics (3PL) operations—optimizing OpEx and sustainability commitments" 
                />
              </Link>
            </article>
            <article className="carousel-card">
              <Link to="/commercial-solar" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Card 
                  title="Rooftop Solar for Commercial Buildings" 
                  img="card2.png" 
                  text="Power your business with commercial rooftop solar. Cut operational costs by 60-80%, improve sustainability, and enjoy tax incentives and rebates." 
                />
              </Link>
            </article>
            <article className="carousel-card">
              <Link to="/residential-solar" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Card 
                  title="Rooftop Solar for Houses" 
                  img="card1.png" 
                  text="Transform your home with rooftop solar panels. Reduce electricity bills by up to 90% while increasing property value. Clean, reliable energy for your family." 
                />
              </Link>
            </article>
          </div>
          <button 
            className="carousel-btn carousel-btn-right" 
            onClick={() => scrollCarousel('right')}
            aria-label="Scroll right"
          >
            &#8250;
          </button>
        </div>
    </section>
  );
}
export default Services;
